import React, { useEffect } from "react";
import "./Admission_Process.css";

import CommonHeading from "../../common-component/common-heading/CommonHeading";
import { useLocation } from "react-router-dom";

const processData = [
  {
    no: "01",
    title: "Submit Application",
    desc: "Complete the online application form and submit required documents.",
  },
  {
    no: "02",
    title: "Reserve Your Seat",
    desc: "Secure your seat by completing the program fee payment.",
  },
  {
    no: "03",
    title: "Start Learning",
    desc: "Begin your learning journey on the designated cohort start date.",
  },
];

const AdmissionProcess = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <section className="admission_process" id="admissionprocess">
      <div className="container">
        {/* Heading */}
        <div className="section_heading">
          <CommonHeading
            subTitle="Take the First Step Towards"
            title="Your MBA"
          />
        </div>

        <div className="admission_wrapper">
          {/* Left Section */}
          <div className="admission_left">
            <span className="apply_tag">Who Can Apply</span>

            <div className="eligibility_item">
              <h4>Eligibility Criteria - Bachelor's Degree Holders</h4>
              <p>
                Candidates with a recognized undergraduate degree and a minimum
                of 50% aggregate marks.
              </p>
            </div>

            <div className="eligibility_item">
              <h4>Working Professionals</h4>
              <p>
                Individuals looking to enhance their managerial capabilities and
                accelerate career growth.
              </p>
            </div>

            <div className="eligibility_item">
              <h4>Future Leaders & Entrepreneurs</h4>
              <p>
                Aspiring professionals seeking business, leadership and
                strategic decision-making skills.
              </p>
            </div>
          </div>

          {/* Right Section */}
          <div className="admission_right">
            <span className="process_tag">Admission Process</span>

            <div className="timeline">
              {processData.map((item, index) => (
                <div className="timeline_item" key={index}>
                  <div className="number_box">
                    {index !== processData.length - 1 && (
                      <span className="timeline_line"></span>
                    )}
                    {item.no}
                  </div>

                  <div className="timeline_content">
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>

                  {/* {index !== processData.length - 1 && (
                    <span className="timeline_line"></span>
                  )} */}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdmissionProcess;
